import dayjs from 'dayjs'

export default function (v: string | null) {
  return dayjs(v).format('Do MMM YYYY HH:mm')
}
